import services from '../../routes/services'
import {
    extractCloudinaryPublicId,
    getRadioCloudinaryCredentials,
} from './cloudinaryCredentials'

async function uploadCloudinary(key, file, serviceOrOptions = 'uploadCloudImage') {
    const options =
        typeof serviceOrOptions === 'string'
            ? { service: serviceOrOptions }
            : serviceOrOptions || {}
    const service = options.service || 'uploadCloudImage'
    const credentials = getRadioCloudinaryCredentials(options.credentials)
    const publicId = options.replaceUrl
        ? extractCloudinaryPublicId(options.replaceUrl)
        : null

    const formData = new FormData()
    const config = { headers: { 'content-type': 'multipart/form-data' } }

    formData.append('key', key)
    formData.append('attachments', file)

    if (credentials.cloud_name) {
        formData.append('cloud_name', credentials.cloud_name)
        formData.append('cloud_key', credentials.cloud_key)
        formData.append('cloud_secret', credentials.cloud_secret)
    }

    if (publicId) {
        formData.append('public_id', publicId)
    }

    return await services().post(`services/${service}`, formData, config).then(res => {
        return res.data
    })
}

export default uploadCloudinary
